export const SET_USER = 'setUser'
export const SET_ERROR = 'setError'
export const SET_LOADING = 'setLoading'
export const SET_VOCAB = 'setVocab'
export const SET_QUEUE = 'setQueue'
export const SET_LESSONS = 'setLessons'
export const SET_ACTIVE_QUEUE = 'setActiveQueue'
export const SET_PRACTICE_QUEUE = 'setPracticeQueue'
export const SET_UNSTUDIED_VOCAB = 'setUnstudiedVocab'
export const SET_CURRENT_LESSON = 'setCurrentLesson'